import { AnyAction } from 'redux';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { BasisAdresse } from '@ps20-frontend/frontend-models';
import { TkvActions } from '../tkvActions';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case TkvActions.PLZ_CHANGED: {
      const plz = action.payload;
      return {
        plz,
        strasse: '',
        hausnummer: '',
        ort: '',
      };
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.TKV_BASISDATEN) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        const newState: BasisAdresse = { ...sectionState };
        newState.ort = payload.orte[0];
        return newState;
      }
      return sectionState;
    }
    case TkvActions.ORT_CHANGED: {
      return { ...sectionState, ort: action.payload };
    }
    case TkvActions.STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload };
    }
    case TkvActions.HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload };
    }

    default:
      return sectionState;
  }
};
